<table mat-table [dataSource]="rows" class="table">
    <!-- supplier -->
    <ng-container matColumnDef="supplierName">
        <th mat-header-cell *matHeaderCellDef class="row-spacing">Supplier</th>
        <td mat-cell *matCellDef="let element" class="row-spacing">
            <ng-container *ngFor="let municipality of element.municipalityFeesOverviewDTOS">
                <app-table-data-field
                    [subElement]="element.supplierDTO.supplierName"
                    [shouldAppearTransclusent]="element.mfAfterCampaignApproved"
                ></app-table-data-field>
                <br
            /></ng-container>
        </td>
    </ng-container>

    <!-- location -->
    <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef class="row-spacing">Location</th>
        <td mat-cell *matCellDef="let element" class="row-spacing">
            <ng-container *ngFor="let municipality of element.municipalityFeesOverviewDTOS">
                <app-table-data-field
                    [subElement]="municipality.location"
                    [shouldAppearTransclusent]="element.mfAfterCampaignApproved"
                ></app-table-data-field>
                <br
            /></ng-container>
        </td>
    </ng-container>

    <!-- cost -->
    <ng-container matColumnDef="cost">
        <th mat-header-cell *matHeaderCellDef>
            Municipality Fees Charges
            <span
                matTooltip="These municipality fees are estimates 
                and will be updated once the actual fees are available"
                style="background: transparent; cursor: pointer"
            >
                <mat-icon style="font-size: medium">info</mat-icon>
            </span>
        </th>
        <td mat-cell *matCellDef="let element">
            <ng-container *ngFor="let municipality of element.municipalityFeesOverviewDTOS">
                <app-table-data-field
                    [visibiltyConditions]="[
                        {
                            ifCond: municipality.cost.value != null,
                            then: municipality.cost.value | currency: municipality.cost.currencyCode
                        },
                        { ifCond: municipality == null, then: 0 }
                    ]"
                    [shouldAppearTransclusent]="element.mfAfterCampaignApproved"
                ></app-table-data-field>
                <br />
            </ng-container>
        </td>
    </ng-container>

    <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="9999" style="text-align: center">
            No municipality fees applicable to your selection
        </td>
    </tr>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
</table>
